<template>
    <v-form>
        <span class="text-subtitle-1 font-weight-medium">{{ $t(`details`) }} </span>
        <v-row>
            <v-col cols="12" md="2">
                <v-text-field
                    v-model="product.pickUpPoint"
                    variant="outlined"
                    density="compact"
                    :label="`${$t('pick_up_point')}`"
                    hide-details
                />
            </v-col>
            <v-col cols="12" md="2">
                <time-field
                    v-model="product.pickUpTime"
                    outlined
                    dense
                    hide-details
                    class="cursor-pointer"
                    :label="`${$t('pick_up_time')}`"
                />
            </v-col>
            <v-col cols="12" md="2">
                <v-text-field
                    v-model="product.dropOffPoint"
                    variant="outlined"
                    density="compact"
                    :label="`${$t('drop_off_point')}`"
                    hide-details
                />
            </v-col>
            <v-col cols="12" md="2">
                <time-field
                    v-model="product.dropOffTime"
                    outlined
                    dense
                    hide-details
                    class="cursor-pointer"
                    :label="`${$t('drop_off_time')}`"
                />
            </v-col>
            <v-col cols="12" md="2">
                <v-text-field
                    v-model="product.vehicleCategory"
                    variant="outlined"
                    density="compact"
                    :label="`${$t('filterTitles.vehicle_type')}`"
                    hide-details
                />
            </v-col>
        </v-row>
    </v-form>
</template>

<script lang="ts">
    import {Component, Prop, VModel, Vue} from 'vue-facing-decorator'
    import TimeField from '@/components/snippets/forms/TimeField.vue'

    @Component({
        components: {TimeField},
    })
    export class OfflineServiceFormCars extends Vue {
        @Prop() productType
        @Prop() tourists
        @VModel() product
    }

    export default OfflineServiceFormCars
</script>
